import { gql } from 'graphql-tag';
import { TypedDocumentNode } from '@apollo/client';

import { DefaultApiResponse, DefaultArg } from '@libs/graphql';
import { CurrencyType } from '@libs/types';

export type walletPayment = {
  amount: number;
  asset: CurrencyType;
};
export type CreateCardlessDirectCryptoTransactionArgs = {
  baseAssetCode: string;
  walletPaymentRecord: walletPayment;
};

export type CreateCardlessDirectCryptoTransactionRes = {
  token: string;
};

export type CreateCardlessDirectCryptoTransactionResponse = {
  createCardlessDirectCryptoTransaction: DefaultApiResponse<CreateCardlessDirectCryptoTransactionRes>;
};

export const createCardlessDirectCryptoTransactionMutation: TypedDocumentNode<
  CreateCardlessDirectCryptoTransactionResponse,
  DefaultArg<CreateCardlessDirectCryptoTransactionArgs>
> = gql`
  mutation CreateCardlessDirectCryptoTransaction(
    $record: CardlessDirectCryptoRecord!
  ) {
    createCardlessDirectCryptoTransaction(record: $record) {
      token
    }
  }
`;
